import { render } from "./kg-dispute.vue?vue&type=template&id=ed1b5332&ts=true"
import script from "./kg-dispute.vue?vue&type=script&lang=ts"
export * from "./kg-dispute.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__